import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface SelectOption {
  label: string
  value: string
}

interface BooleanLabels {
  true: string
  false: string
}

export function useBooleanSelectOption(value: boolean | undefined, labels?: BooleanLabels): SelectOption | undefined {
  const { t } = useTranslation()

  const defaultLabels: BooleanLabels = useMemo(
    () => ({
      true: t('grants.program.modal.option.yes'),
      false: t('grants.program.modal.option.no')
    }),
    [t]
  )

  const selectedLabels = labels ?? defaultLabels

  return useMemo(
    () =>
      typeof value === 'boolean'
        ? {
            label: value ? selectedLabels.true : selectedLabels.false,
            value: String(value)
          }
        : undefined,
    [value, selectedLabels]
  )
}
